var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[(_vm.isLoading)?_c('LoadingSpinner'):_c('donation-form',{on:{"request-payments":_vm.requestPayment}}),(_vm.showTosspaymentModal)?_c('TossPayment',{attrs:{"paymentInfo":_vm.paymentInfo},on:{"close":function($event){_vm.showTosspaymentModal = false}}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }